import './method.scss';

export default () => {
	$( '.method__button' ).on( 'click', function ( event ) {
		event.preventDefault();

		$( 'html, body' ).animate( {
			scrollTop: $( this ).closest( 'section' ).next().offset().top,
		}, 500 );
	} );
};
